// VOLT scratch-to-reveal mystery discount popup - strict three-state machine.
//
//   'scratch'   -> covered panel + scratch heading + skip link. Nothing later is visible.
//   'revealed'  -> panel cleared to the teaser (no % / no code) + email prompt + input + submit.
//   'submitted' -> success REPLACES the form: description, code + copy button, emailed-too line.
//
// One state variable drives everything (setState). The success-state content does not exist in
// the DOM until it's earned: it's cloned from an inert <template> and the code injected there,
// decoded from a base64 data attribute (client-side reveal can't be a cryptographic secret, but
// the plain code never sits in the rendered DOM or casual view-source before submit).
//
// EMAIL AUTOMATION HOOK: submitting tags the customer `scratch-signup` in Shopify. The "on its
// way to your inbox" line is only true once a Shopify Email automation (or Klaviyo flow)
// triggered by that tag exists in Admin - create it, or the on-screen code is the only delivery.
//
// PERSISTENCE: first-party cookies, NOT localStorage - survives storage-restricted browsing
// modes. volt_scratch_done (1yr) suppresses the popup after a completed signup;
// volt_scratch_dismissed (session) collapses it to the corner tab for the rest of the visit.
//
// KLAVIYO SWAP POINT: replace the submit handler's fetch (and the form markup in
// snippets/volt-scratch-card.liquid) to capture into Klaviyo instead.
(function () {
  var dialog = document.querySelector('[data-volt-scratch]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var COOKIE_DONE = 'volt_scratch_done';
  var COOKIE_DISMISSED = 'volt_scratch_dismissed';
  var CLEAR_THRESHOLD = 0.55;

  function getCookie(name) {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(name + '=') === 0;
    });
  }

  function setCookie(name, maxAgeSeconds) {
    var cookie = name + '=1; path=/; SameSite=Lax';
    if (maxAgeSeconds) cookie += '; max-age=' + maxAgeSeconds;
    document.cookie = cookie;
  }

  if (getCookie(COOKIE_DONE)) return;

  var card = dialog.querySelector('[data-volt-scratch-card]');
  var tab = document.querySelector('[data-volt-scratch-tab]');
  var canvas = dialog.querySelector('[data-volt-scratch-canvas]');
  var panel = dialog.querySelector('[data-volt-scratch-panel]');
  var headingScratch = dialog.querySelector('[data-volt-scratch-heading-scratch]');
  var headingUnlock = dialog.querySelector('[data-volt-scratch-heading-unlock]');
  var skipLink = dialog.querySelector('[data-volt-scratch-skip]');
  var unlockBlock = dialog.querySelector('[data-volt-scratch-unlock]');
  var doneShell = dialog.querySelector('[data-volt-scratch-done]');
  var doneTemplate = dialog.querySelector('[data-volt-scratch-done-template]');
  var form = dialog.querySelector('.volt-scratch__form');
  var emailInput = dialog.querySelector('#VoltScratchEmail');
  var errorEl = dialog.querySelector('[data-volt-scratch-error]');

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var delayMs = (parseInt(dialog.dataset.delaySeconds, 10) || 10) * 1000;
  var scrollPercent = parseInt(dialog.dataset.scrollPercent, 10) || 50;

  var triggered = false;
  var scratchInited = false;
  var doneBuilt = false;

  // ---- The state machine. Exactly one state's blocks are visible at any moment. ----

  var state = 'scratch';

  function setState(next) {
    state = next;
    card.dataset.state = next;

    // scratch: heading A + covered panel + skip. revealed: heading B + cleared panel + form.
    // submitted: done content only.
    headingScratch.hidden = next !== 'scratch';
    skipLink.hidden = next !== 'scratch';
    headingUnlock.hidden = next !== 'revealed';
    unlockBlock.hidden = next !== 'revealed';
    panel.hidden = next === 'submitted';
    doneShell.hidden = next !== 'submitted';

    if (next === 'revealed') {
      // Whatever path led here (scratch completed, skip link, reduced-motion reveal), the
      // panel must show the cleared teaser, never a half-covered canvas.
      canvas.classList.add('volt-scratch__canvas--cleared');
      emailInput.focus();
    }

    if (next === 'submitted') {
      buildDoneState();
      var copyBtn = doneShell.querySelector('[data-volt-scratch-copy]');
      if (copyBtn) copyBtn.focus();
    }
  }

  // Success content is cloned out of the inert <template> only when earned - before this runs,
  // no code/description/confirmation exists in the rendered DOM at all.
  function buildDoneState() {
    if (doneBuilt) return;
    doneBuilt = true;

    doneShell.appendChild(doneTemplate.content.cloneNode(true));

    var code = '';
    try {
      code = atob(dialog.dataset.codeB64 || '');
    } catch (err) {
      code = dialog.dataset.codeB64 || '';
    }
    doneShell.querySelector('[data-volt-scratch-final-code]').textContent = code;

    var copyBtn = doneShell.querySelector('[data-volt-scratch-copy]');
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(code).then(function () {
        copyBtn.querySelector('.volt-cta-button__label').textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.querySelector('.volt-cta-button__label').textContent = 'Copy';
        }, 2000);
      });
    });
  }

  // ---- Open/close/dismiss ----

  function anotherModalOpen() {
    var dialogs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i] !== dialog) return true;
    }
    return false;
  }

  function openDialog() {
    if (dialog.open) return;
    dialog.showModal();
    document.body.setAttribute('data-volt-modal-open', '');
    if (tab) tab.hidden = true;
    if (!scratchInited && state === 'scratch') initScratch();
  }

  // Idempotent cleanup, wired to every close path (button, Esc/cancel, native close event).
  // Some embedded/webview browsers fail to fire <dialog>'s close event, so cleanup is called
  // explicitly from each path rather than relying on the event alone.
  function onDialogClosed() {
    document.body.removeAttribute('data-volt-modal-open');
    if (!getCookie(COOKIE_DONE)) {
      setCookie(COOKIE_DISMISSED); // session cookie - re-offers next visit
      if (tab) tab.hidden = false;
    }
  }

  function closeDialog() {
    if (dialog.open) dialog.close();
    onDialogClosed();
  }

  dialog.addEventListener('close', onDialogClosed);
  dialog.addEventListener('cancel', function () {
    setTimeout(onDialogClosed, 0);
  });

  dialog.querySelector('[data-volt-scratch-close]').addEventListener('click', closeDialog);

  if (tab) {
    tab.addEventListener('click', openDialog);
  }

  function trigger() {
    if (triggered) return;
    triggered = true;
    if (anotherModalOpen()) {
      // Don't stack on another modal - fall back to the corner tab instead.
      if (tab) tab.hidden = false;
      return;
    }
    openDialog();
  }

  if (getCookie(COOKIE_DISMISSED)) {
    // Dismissed earlier this visit - just show the corner tab, no auto-popup.
    if (tab) tab.hidden = false;
  } else {
    setTimeout(trigger, delayMs);
    var onScroll = function () {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && (window.scrollY / scrollable) * 100 >= scrollPercent) {
        window.removeEventListener('scroll', onScroll);
        trigger();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- Scratch canvas (lazy-initialised only when the popup first opens) ----

  function initScratch() {
    scratchInited = true;

    // Reduced motion: no scratch interaction or particles - a plain Reveal button instead,
    // which advances to the same 'revealed' state instantly.
    if (prefersReducedMotion) {
      canvas.style.display = 'none';
      var revealBtn = document.createElement('button');
      revealBtn.type = 'button';
      revealBtn.className = 'button volt-cta-button';
      revealBtn.innerHTML = '<span class="volt-cta-button__label">Reveal</span>';
      canvas.parentElement.appendChild(revealBtn);
      revealBtn.style.position = 'absolute';
      revealBtn.style.inset = '0';
      revealBtn.style.width = '100%';
      revealBtn.addEventListener('click', function () {
        revealBtn.remove();
        setState('revealed');
      });
      return;
    }

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var rect = canvas.getBoundingClientRect();
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
    ctx.scale(dpr, dpr);
    var w = rect.width;
    var h = rect.height;

    var styles = getComputedStyle(document.documentElement);
    var gold = (styles.getPropertyValue('--volt-gold') || '#f5c842').trim();

    // Paint the "foil" cover: matte charcoal with faint gold linework + SCRATCH label.
    ctx.fillStyle = '#181818';
    ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = gold;
    ctx.globalAlpha = 0.12;
    for (var gx = 0; gx < w; gx += w / 7) {
      ctx.beginPath();
      ctx.moveTo(gx, 0);
      ctx.lineTo(gx, h);
      ctx.stroke();
    }
    for (var gy = 0; gy < h; gy += h / 4) {
      ctx.beginPath();
      ctx.moveTo(0, gy);
      ctx.lineTo(w, gy);
      ctx.stroke();
    }
    ctx.globalAlpha = 0.5;
    ctx.lineWidth = 2;
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(w / 2 + 4, h / 2 - 26);
    ctx.lineTo(w / 2 - 12, h / 2 + 8);
    ctx.lineTo(w / 2 - 2, h / 2 + 8);
    ctx.lineTo(w / 2 - 6, h / 2 + 34);
    ctx.lineTo(w / 2 + 14, h / 2 - 2);
    ctx.lineTo(w / 2 + 2, h / 2 - 2);
    ctx.closePath();
    ctx.stroke();
    ctx.globalAlpha = 0.7;
    ctx.fillStyle = gold;
    ctx.font = '500 11px "DM Mono", ui-monospace, monospace';
    ctx.textAlign = 'center';
    ctx.fillText('S C R A T C H', w / 2, h - 14);
    ctx.globalAlpha = 1;

    // Gold spark particles at the scratch point - small, capped, cheap.
    var sparks = [];
    var MAX_SPARKS = 24;

    function spawnSparks(x, y) {
      for (var i = 0; i < 2 && sparks.length < MAX_SPARKS; i++) {
        sparks.push({
          x: x,
          y: y,
          vx: (Math.random() - 0.5) * 2.4,
          vy: -Math.random() * 2 - 0.5,
          life: 1,
        });
      }
    }

    var sparkRaf = null;

    function drawSparks() {
      sparkRaf = null;
      if (!sparks.length) return;
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      sparks = sparks.filter(function (s) {
        s.x += s.vx;
        s.y += s.vy;
        s.vy += 0.15;
        s.life -= 0.06;
        if (s.life <= 0) return false;
        ctx.globalAlpha = s.life * 0.8;
        ctx.fillStyle = gold;
        ctx.fillRect(s.x, s.y, 2, 2);
        return true;
      });
      ctx.restore();
      if (sparks.length) sparkRaf = requestAnimationFrame(drawSparks);
    }

    var scratching = false;
    var strokes = 0;
    var cleared = false;

    function scratchAt(x, y) {
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      var grad = ctx.createRadialGradient(x, y, 6, x, y, 22);
      grad.addColorStop(0, 'rgba(0,0,0,1)');
      grad.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(x, y, 22, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();

      spawnSparks(x, y);
      if (!sparkRaf) sparkRaf = requestAnimationFrame(drawSparks);

      strokes++;
      if (strokes % 8 === 0) checkCleared();
    }

    function checkCleared() {
      if (cleared) return;
      // Sample a coarse grid rather than every pixel - cheap and accurate enough.
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var step = 16 * 4;
      var transparent = 0;
      var total = 0;
      for (var i = 3; i < data.length; i += step) {
        total++;
        if (data[i] < 128) transparent++;
      }
      if (transparent / total >= CLEAR_THRESHOLD) {
        cleared = true;
        canvas.classList.add('volt-scratch__canvas--cleared');
        setTimeout(function () {
          setState('revealed');
        }, 550);
      }
    }

    function pointerPos(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }

    canvas.addEventListener('pointerdown', function (e) {
      scratching = true;
      try {
        canvas.setPointerCapture(e.pointerId);
      } catch (err) {
        // Synthetic events / some Safari edge cases have no capturable pointer - scratching
        // still works without capture, the drag just ends at the canvas edge.
      }
      var p = pointerPos(e);
      scratchAt(p.x, p.y);
    });

    canvas.addEventListener('pointermove', function (e) {
      if (!scratching) return;
      var p = pointerPos(e);
      scratchAt(p.x, p.y);
    });

    canvas.addEventListener('pointerup', function () {
      scratching = false;
      checkCleared();
    });
  }

  // Accessibility fallback - jumps to the email prompt (state 2), never straight to the code.
  skipLink.addEventListener('click', function () {
    setState('revealed');
  });

  // ---- Email gate ----

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
    emailInput.setAttribute('aria-invalid', 'true');
    emailInput.focus();
  }

  // AJAX-submit the rendered {% form 'customer' %}'s own FormData (carries Shopify's generated
  // form_type/utf8 fields - a hand-built body 403s). If Shopify's bot-verification challenge
  // intercepts the AJAX POST, fall back to a NATIVE submit: the challenge page renders, the
  // visitor completes it, Shopify processes the signup and redirects back to return_to
  // (?scratch-unlocked=1), where the loader below resumes at the success state.
  // KLAVIYO: replace this handler + the form markup in the snippet.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;
    emailInput.removeAttribute('aria-invalid');

    // Never advance on an empty or invalid email - inline error, stay in state 2.
    var email = emailInput.value.trim();
    if (!email) {
      showError('Please enter your email address.');
      return;
    }
    if (!validEmail(email)) {
      showError('Please enter a valid email address.');
      return;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;

    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
    })
      .then(function (res) {
        if (res.status === 403) {
          // Bot challenge - hand off to a full-page submit so it can actually be completed.
          form.submit();
          return null;
        }
        if (!res.ok) throw new Error('bad status ' + res.status);
        completeSignup();
        return null;
      })
      .catch(function () {
        showError('Something went wrong - please try again.');
      })
      .finally(function () {
        submitBtn.disabled = false;
      });
  });

  function completeSignup() {
    setCookie(COOKIE_DONE, 31536000); // 1 year
    setState('submitted');
  }

  // Returning from the native-submit (bot challenge) fallback: reopen straight at the success
  // state - the email was captured by Shopify during the full-page submit.
  if (window.location.search.indexOf('scratch-unlocked=1') > -1) {
    window.history.replaceState(null, '', window.location.pathname);
    triggered = true;
    openDialog();
    completeSignup();
  }
})();
